import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';

import { fixResolution } from './canvas-util';
import { from, Breakpoints } from '../utils/theme';

const StyledCanvas = styled.canvas`
  background-color: #1e1e1e;
  width: 100%;
  min-height: 300px;

  ${from(Breakpoints.MD, 'min-height: 400px;')}
`;

type Props = {
  colors?: string[];
  paint: (
    cavansRef: React.MutableRefObject<HTMLCanvasElement>,
    ctx: CanvasRenderingContext2D
  ) => void;
};

const Canvas: React.FC<Props> = ({ paint }) => {
  let ctx: CanvasRenderingContext2D;
  const canvasRef = useRef(null);

  const getContext = () =>
    (ctx = fixResolution(canvasRef.current, window.devicePixelRatio));

  useEffect(() => {
    if (!ctx) {
      getContext();
    }

    paint(canvasRef, ctx);
  }, [paint]);

  useEffect(() => {
    if (!ctx) {
      getContext();
    }

    window.addEventListener('resize', getContext);

    return () => {
      window.removeEventListener('resize', getContext);
    };
  }, []);

  return <StyledCanvas ref={canvasRef}></StyledCanvas>;
};

export default Canvas;
